import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAmexWrapper from '@americanexpress/one-app-module-wrapper';
import { connect } from 'react-redux';
import SharedScript from '@americanexpress/shared-scripts';
import Helmet from 'react-helmet';
import { getEnvironment } from '../selectors';
import config from '../config.json';

// for devmode, paste the contents of @amex-eng/one-identity-session/dist/frames.js or core.js into
// development/frames or /core and change the isDevMode prop to true
export function UniversalSessionManagerWrapper({
  children,
  baseUrl,
  version = config.version,
  isDevMode = config.isDevMode,
}) {
  let usmScript = null;
  const loadUSM = async () => {
    await import('../../development/modules/frames');
  };

  const handleMessage = (event) => {
    if (event?.data?.messageId === 'OPTIONS_COUNT') {
      const { options: { counts } } = event.data;
      // if (window.document.querySelector('#amexSessionFrameContainer')) {
      const height = !!counts && counts < 10 ? 250 + (counts * 50) : 600;
      if (counts) {
        window.document.querySelector('#amexSessionFrameContainer').style.maxHeight = `${Math.round(height)}px`;
      } else {
        window.document.querySelector('#amexSessionFrameContainer').style.maxHeight = '390px';
      }
      // }
    }
  };
  window.addEventListener('message', handleMessage);

  useEffect(() => () => window.removeEventListener('message', handleMessage), []);

  if (global.BROWSER) {
    if (isDevMode) {
      loadUSM();
    } else if (version) {
      usmScript = (
        <Helmet>
          <script type="text/javascript" src={`${baseUrl}/${version}/frames.js`} />
        </Helmet>
      );
    } else {
      usmScript = (
        <SharedScript
          name="identity-ui-session-toolkit"
          version="^2.0.0"
          windowCheck="IdentityToolkit"
        />
      );
    }
  }
  return (
    <React.Fragment>
      {children}
      {usmScript}
    </React.Fragment>
  );
}

UniversalSessionManagerWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  version: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  isDevMode: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state, ownProps) => {
  const { version, isDevMode } = ownProps.route;
  return {
    isDevMode,
    version,
    baseUrl: getEnvironment(state),
  };
};

const hocChain = compose(
  oneAmexWrapper('one-identity-universal-session-manager'),
  connect(mapStateToProps)
);

export default hocChain(UniversalSessionManagerWrapper);
